import request from "@/utils/request";

export function getformsConference(data) {
  return request({
    url: `mobile-notifications/forms-conference`,
    method: "post",
    data,
  });
}

export function createNotification(data) {
  return request({
    url: `mobile-notifications/create-notification`,
    method: "post",
    data,
  });
}
export function notificationSearch(data) {
  return request({
    url: `mobile-notifications/search`,
    method: "post",
    data,
  });
}

// Get a list of notifications ---Fake for not 
// TODO: rm those
export function notificationsList(data) {
  
}

// Get unseen notifications count
export function UnseenCount() {
 
}

// Mark all notifications as seen
export function markAllAsSeen(data) {
 
}

// See one notification (mark as seen)
export function seeOneNotification(id) {

}

// Delete notification(s)
export function deleteNotification(data) {
 
}
